webpackJsonp([57],{

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API_ROOT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(88);


var API_ROOT = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* default */].API_ROOT + '/';

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return buildUri; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return leadershipTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return roleTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addressTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return countries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getPermission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(24);


var buildUri = function buildUri(params) {
    var extension = '';
    if (params) {
        _.each(params, function (value, key) {
            if (value) {
                if (!extension) {
                    extension = '?';
                } else {
                    extension += '&';
                }
                extension += key + '=' + value;
            }
        });
    }
    return extension;
};

var getOptions = function getOptions() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    var argString = args.join(',');
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'options?fields=' + argString;
};

var leadershipTypes = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'leadership-types';

var roleTypes = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'role-types';

var addressTypes = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'address-types';

var countries = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'countries';

var getPermission = function getPermission() {
    var objectType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var objectId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var params = objectType && objectId ? '?object_type=' + objectType + '&object_id=' + objectId : '';

    var url = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'me/permissions' + params;

    return url;
};

/***/ }),

/***/ 255:
/***/ (function(module, exports, __webpack_require__) {


__webpack_require__(345);
__webpack_require__(428);
__webpack_require__(426);
__webpack_require__(277);
__webpack_require__(424);

__webpack_require__(414);
__webpack_require__(413);
__webpack_require__(417);
__webpack_require__(415);

__webpack_require__(416);

/***/ }),

/***/ 256:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__guest__ = __webpack_require__(327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__collections__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__entities__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upload__ = __webpack_require__(274);











/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__guest__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__collections__["b" /* default */], __WEBPACK_IMPORTED_MODULE_3__entities__["a" /* default */], {
    profile: {
        get: __WEBPACK_IMPORTED_MODULE_4__profile__["o" /* get */],
        searchUsers: __WEBPACK_IMPORTED_MODULE_4__profile__["p" /* searchUsers */],
        userNotes: __WEBPACK_IMPORTED_MODULE_4__profile__["q" /* userNotes */]
    },
    upload: __WEBPACK_IMPORTED_MODULE_6__upload__["a" /* upload */],
    leadershipTypes: __WEBPACK_IMPORTED_MODULE_5__index__["c" /* leadershipTypes */],
    roleTypes: __WEBPACK_IMPORTED_MODULE_5__index__["d" /* roleTypes */],
    addressTypes: __WEBPACK_IMPORTED_MODULE_5__index__["e" /* addressTypes */],
    countries: __WEBPACK_IMPORTED_MODULE_5__index__["f" /* countries */],
    getPermission: __WEBPACK_IMPORTED_MODULE_5__index__["g" /* getPermission */],
    getOptions: __WEBPACK_IMPORTED_MODULE_5__index__["b" /* getOptions */],
    collectionProfiles: __WEBPACK_IMPORTED_MODULE_2__collections__["c" /* collectionProfiles */]
}));

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_chart_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_chart_js__);


__WEBPACK_IMPORTED_MODULE_0_chart_js___default.a.plugins.register({
    afterDraw: function afterDraw(chart) {
        if (!chart.data.datasets[0].data.filter(function (item) {
            return item;
        }).length) {
            var ctx = chart.chart.ctx;
            var width = chart.chart.width;
            var height = chart.chart.height;


            ctx.save();
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            ctx.font = "16px";
            ctx.fillText('No data to display', width / 2, height / 2);
            ctx.restore();
        }
    }
});

/***/ }),

/***/ 258:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resources__ = __webpack_require__(328);



/* harmony default export */ __webpack_exports__["a"] = ({
    performOauth2Authorize: function performOauth2Authorize(provider) {
        var query = '?client_id=' + provider.clientId + '&redirect_uri=' + provider.redirect + '&scope=' + provider.scope + '&response_type=' + provider.responseType + '&state=' + encodeURIComponent(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(provider.state));

        window.location = provider.url + query;

        this.authenticated = true;
    },
    authUser: function authUser(context, token, callback) {
        var url = config.AUTH_USER_URL;

        __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].setToken(token);

        __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].fetchUser(context, url, callback);
    },
    logout: function logout() {
        __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].clearUserResource();
    },
    checkAuth: function checkAuth() {
        var jwt = __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].getToken();

        if (!jwt) {
            this.logout();
            return false;
        }

        return true;
    },
    getUser: function getUser() {
        return __WEBPACK_IMPORTED_MODULE_1__resources__["a" /* default */].getOauthUser();
    },
    isSuperMan: function isSuperMan() {
        return this.getUser().is_super_man;
    }
});

/***/ }),

/***/ 259:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_commons_Login__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_commons_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_commons_Login__);




var Home = function Home() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 517));
};
var Collection = function Collection() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 505));
};
var CollectionRole = function CollectionRole() {
    return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 504));
};

var Entity = function Entity() {
    return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 516));
};
var EntityDashboard = function EntityDashboard() {
    return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 526));
};
var Members = function Members() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 531));
};
var JoinRequests = function JoinRequests() {
    return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 528));
};
var Entities = function Entities() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 525));
};
var Calendar = function Calendar() {
    return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 522));
};
var Announcements = function Announcements() {
    return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 519));
};
var AnnouncementsView = function AnnouncementsView() {
    return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 521));
};
var NewAnnouncement = function NewAnnouncement() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 520));
};
var AnnouncementEdit = function AnnouncementEdit() {
    return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 518));
};
var Events = function Events() {
    return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 527));
};
var Contributions = function Contributions() {
    return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 524));
};
var MyCongress = function MyCongress() {
    return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 532));
};
var Configuration = function Configuration() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 523));
};
var EntityRole = function EntityRole() {
    return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 550));
};

var MemberProfile = function MemberProfile() {
    return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 530));
};
var MemberNotes = function MemberNotes() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 529));
};

var Resources = function Resources() {
    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 541));
};
var ResourcePhotos = function ResourcePhotos() {
    return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 546));
};
var PhotosAlbumView = function PhotosAlbumView() {
    return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 547));
};
var NewAlbum = function NewAlbum() {
    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 545));
};
var PhotosAlbumEdit = function PhotosAlbumEdit() {
    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 540));
};

var ResourceAudios = function ResourceAudios() {
    return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 537));
};
var AudioAdd = function AudioAdd() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 535));
};
var AudioView = function AudioView() {
    return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 536));
};

var ResourceVideos = function ResourceVideos() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 549));
};
var VideoView = function VideoView() {
    return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 548));
};
var AddVideo = function AddVideo() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 534));
};

var ResourceDocs = function ResourceDocs() {
    return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 538));
};
var AddDocument = function AddDocument() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 533));
};
var DocumentView = function DocumentView() {
    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 539));
};

var Links = function Links() {
    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 544));
};
var LinkAdd = function LinkAdd() {
    return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 542));
};
var LinkView = function LinkView() {
    return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 543));
};

var About = function About() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 551));
};
var Contact = function Contact() {
    return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 553));
};
var Citizenship = function Citizenship() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 552));
};
var Family = function Family() {
    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 556));
};
var Membership = function Membership() {
    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 557));
};
var Employments = function Employments() {
    return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 555));
};
var Educations = function Educations() {
    return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 554));
};
var Skills = function Skills() {
    return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 558));
};
var Social = function Social() {
    return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 559));
};

var CollectionProfile = {
    Landing: function Landing() {
        return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 506));
    },
    Profile: function Profile() {
        return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 513));
    },
    About: function About() {
        return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 507));
    },
    Contact: function Contact() {
        return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 509));
    },
    Citizenship: function Citizenship() {
        return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 508));
    },
    Membership: function Membership() {
        return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 512));
    },
    Employments: function Employments() {
        return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 511));
    },
    Educations: function Educations() {
        return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 510));
    },
    Skills: function Skills() {
        return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 514));
    },
    Social: function Social() {
        return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 515));
    }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    linkActiveClass: 'active',
    base: __dirname,
    routes: [{
        path: '/',
        name: 'login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_commons_Login___default.a,
        meta: { requiresAuth: false }
    }, {
        path: '/dashboard',
        name: 'dashboard',
        component: Home,
        meta: { requiresAuth: true }
    }, {
        path: '/collection/:collection_id',
        name: 'collection',
        component: Collection,
        props: true,
        meta: { requiresAuth: true }
    }, {
        path: '/collection/:collection_id/roles',
        name: 'collection.roles',
        component: CollectionRole,
        props: true,
        meta: { requiresAuth: true }
    }, {
        path: '/collection/:collection_id/entity/:entity_id',
        component: Entity,
        props: true,
        meta: { requiresAuth: true },
        children: [{
            path: 'members',
            name: 'entity.members',
            component: Members,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'join-requests',
            name: 'entity.joinRequests',
            component: JoinRequests,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'dashboard',
            name: 'entity.dashboard',
            component: EntityDashboard,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'entities',
            name: 'entity.entities',
            component: Entities,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'members/:id',
            component: MemberProfile,
            props: true,
            meta: { requiresAuth: true },
            children: [{
                path: 'about',
                name: 'profile.index',
                component: About,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'contact',
                name: 'profile.contact',
                component: Contact,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'citizenship',
                name: 'profile.citizenship',
                component: Citizenship,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'family',
                name: 'profile.family',
                component: Family,
                meta: { requiresAuth: true }
            }, {
                path: 'membership',
                name: 'profile.membership',
                component: Membership,
                meta: { requiresAuth: true }
            }, {
                path: 'employment',
                name: 'profile.employments',
                component: Employments,
                meta: { requiresAuth: true }
            }, {
                path: 'education',
                name: 'profile.educations',
                component: Educations,
                meta: { requiresAuth: true }
            }, {
                path: 'skills',
                name: 'profile.skills',
                component: Skills,
                meta: { requiresAuth: true }
            }, {
                path: 'social',
                name: 'profile.social',
                component: Social,
                meta: { requiresAuth: true }
            }]
        }, {
            path: 'member/:id/notes',
            component: MemberNotes,
            name: 'member.notes',
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'calendar',
            name: 'entity.calendar',
            component: Calendar,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements',
            name: 'entity.announcements',
            component: Announcements,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements/new',
            name: 'entity.announcements.new',
            component: NewAnnouncement,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements/:announcement_id/view',
            name: 'entity.announcements.view',
            component: AnnouncementsView,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements/:announcement_id/edit',
            name: 'entity.announcements.edit',
            component: AnnouncementEdit,
            meta: { requiresAuth: true }
        }, {
            path: 'resources',
            component: Resources,
            meta: { requiresAuth: true },
            children: [{
                path: '',
                name: 'resource.photos',
                component: ResourcePhotos,
                meta: { requiresAuth: true }
            }, {
                path: 'photos/new-album',
                name: 'new-album',
                component: NewAlbum,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'photos/:album_id',
                name: 'resource.photos.album',
                component: PhotosAlbumView,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'photos/:album_id/edit',
                name: 'resource.photos.album.edit',
                component: PhotosAlbumEdit,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios',
                name: 'resource.audios',
                component: ResourceAudios,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios/add',
                name: 'resource.audios.new',
                component: AudioAdd,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios/edit/:audio_id',
                name: 'resource.audios.edit',
                component: AudioAdd,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios/view/:audio_id',
                name: 'resource.audios.view',
                component: AudioView,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos',
                name: 'resource.videos',
                component: ResourceVideos,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos/new',
                name: 'resource.videos.new',
                component: AddVideo,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos/edit/:video_id',
                name: 'resource.videos.edit',
                component: AddVideo,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos/view/:video_id',
                name: 'resource.videos.view',
                component: VideoView,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents',
                name: 'resource.docs',
                component: ResourceDocs,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents/new',
                name: 'resource.docs.new',
                component: AddDocument,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents/edit/:doc_id',
                name: 'resource.docs.edit',
                component: AddDocument,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents/view/:doc_id',
                name: 'resource.docs.view',
                component: DocumentView,
                props: true,
                meta: { requiresAuth: true }
            }]
        }, {
            path: 'links',
            name: 'entity.links',
            component: Links,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'links/add',
            name: 'entity.links.add',
            component: LinkAdd,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'links/edit/:link_id',
            name: 'entity.links.edit',
            component: LinkAdd,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'links/view/:link_id',
            name: 'entity.links.view',
            component: LinkView,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'events',
            name: 'entity.events',
            component: Events,
            meta: { requiresAuth: true }
        }, {
            path: 'contributions',
            name: 'entity.contributions',
            component: Contributions,
            meta: { requiresAuth: true }
        }, {
            path: 'my-congress',
            name: 'entity.my-congress',
            component: MyCongress,
            meta: { requiresAuth: true }
        }, {
            path: 'configuration',
            name: 'entity.config',
            component: Configuration,
            meta: { requiresAuth: true }
        }, {
            path: 'roles',
            name: 'entity.roles',
            component: EntityRole,
            meta: { requiresAuth: true }
        }]
    }, {
        path: '/collection/:collection_id',
        component: CollectionProfile.Landing,
        props: true,
        children: [{
            props: true,
            path: 'members/:id',
            name: 'CollectionProfile',
            component: CollectionProfile.Profile,
            children: [{
                path: 'about',
                name: 'CollectionProfile.about',
                component: CollectionProfile.About,
                props: true
            }, {
                path: 'contact',
                name: 'CollectionProfile.contact',
                component: CollectionProfile.Contact,
                props: true
            }, {
                path: 'citizenships',
                name: 'CollectionProfile.citizenships',
                component: CollectionProfile.Citizenship,
                props: true
            }, {
                path: 'memberships',
                name: 'CollectionProfile.memberships',
                component: CollectionProfile.Membership,
                props: true
            }, {
                path: 'employments',
                name: 'CollectionProfile.employments',
                component: CollectionProfile.Employments,
                props: true
            }, {
                path: 'educations',
                name: 'CollectionProfile.educations',
                component: CollectionProfile.Educations,
                props: true
            }, {
                path: 'skills',
                name: 'CollectionProfile.skills',
                component: CollectionProfile.Skills,
                props: true
            }, {
                path: 'social',
                name: 'CollectionProfile.social',
                component: CollectionProfile.Social,
                props: true
            }]
        }]
    }, {
        path: '/entity/:entity_id',
        component: Entity,
        props: true,
        meta: { requiresAuth: true, entityGlobal: true },
        children: [{
            path: 'members',
            name: 'entityGlobal.entity.members',
            component: Members,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'join-requests',
            name: 'entityGlobal.entity.joinRequests',
            component: JoinRequests,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'dashboard',
            name: 'entityGlobal.entity.dashboard',
            component: EntityDashboard,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'entities',
            name: 'entityGlobal.entity.entities',
            component: Entities,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'members/:id',
            component: MemberProfile,
            props: true,
            meta: { requiresAuth: true },
            children: [{
                path: 'about',
                name: 'entityGlobal.profile.index',
                component: About,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'contact',
                name: 'entityGlobal.profile.contact',
                component: Contact,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'citizenship',
                name: 'entityGlobal.profile.citizenship',
                component: Citizenship,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'family',
                name: 'entityGlobal.profile.family',
                component: Family,
                meta: { requiresAuth: true }
            }, {
                path: 'membership',
                name: 'entityGlobal.profile.membership',
                component: Membership,
                meta: { requiresAuth: true }
            }, {
                path: 'employment',
                name: 'entityGlobal.profile.employments',
                component: Employments,
                meta: { requiresAuth: true }
            }, {
                path: 'education',
                name: 'entityGlobal.profile.educations',
                component: Educations,
                meta: { requiresAuth: true }
            }, {
                path: 'skills',
                name: 'entityGlobal.profile.skills',
                component: Skills,
                meta: { requiresAuth: true }
            }, {
                path: 'social',
                name: 'entityGlobal.profile.social',
                component: Social,
                meta: { requiresAuth: true }
            }]
        }, {
            path: 'member/:id/notes',
            component: MemberNotes,
            name: 'entityGlobal.member.notes',
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'calendar',
            name: 'entityGlobal.entity.calendar',
            component: Calendar,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements',
            name: 'entityGlobal.entity.announcements',
            component: Announcements,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements/new',
            name: 'entityGlobal.entity.announcements.new',
            component: NewAnnouncement,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements/:announcement_id/view',
            name: 'entityGlobal.entity.announcements.view',
            component: AnnouncementsView,
            meta: { requiresAuth: true }
        }, {
            path: 'announcements/:announcement_id/edit',
            name: 'entityGlobal.entity.announcements.edit',
            component: AnnouncementEdit,
            meta: { requiresAuth: true }
        }, {
            path: 'resources',
            component: Resources,
            meta: { requiresAuth: true },
            children: [{
                path: '',
                name: 'entityGlobal.resource.photos',
                component: ResourcePhotos,
                meta: { requiresAuth: true }
            }, {
                path: 'photos/new-album',
                name: 'entityGlobal.new-album',
                component: NewAlbum,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'photos/:album_id',
                name: 'entityGlobal.resource.photos.album',
                component: PhotosAlbumView,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'photos/:album_id/edit',
                name: 'entityGlobal.resource.photos.album.edit',
                component: PhotosAlbumEdit,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios',
                name: 'entityGlobal.resource.audios',
                component: ResourceAudios,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios/add',
                name: 'entityGlobal.resource.audios.new',
                component: AudioAdd,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios/edit/:audio_id',
                name: 'entityGlobal.resource.audios.edit',
                component: AudioAdd,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'audios/view/:audio_id',
                name: 'entityGlobal.resource.audios.view',
                component: AudioView,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos',
                name: 'entityGlobal.resource.videos',
                component: ResourceVideos,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos/new',
                name: 'entityGlobal.resource.videos.new',
                component: AddVideo,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos/edit/:video_id',
                name: 'entityGlobal.resource.videos.edit',
                component: AddVideo,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'videos/view/:video_id',
                name: 'entityGlobal.resource.videos.view',
                component: VideoView,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents',
                name: 'entityGlobal.resource.docs',
                component: ResourceDocs,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents/new',
                name: 'entityGlobal.resource.docs.new',
                component: AddDocument,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents/edit/:doc_id',
                name: 'entityGlobal.resource.docs.edit',
                component: AddDocument,
                props: true,
                meta: { requiresAuth: true }
            }, {
                path: 'documents/view/:doc_id',
                name: 'entityGlobal.resource.docs.view',
                component: DocumentView,
                props: true,
                meta: { requiresAuth: true }
            }]
        }, {
            path: 'links',
            name: 'entityGlobal.entity.links',
            component: Links,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'links/add',
            name: 'entityGlobal.entity.links.add',
            component: LinkAdd,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'links/edit/:link_id',
            name: 'entityGlobal.entity.links.edit',
            component: LinkAdd,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'links/view/:link_id',
            name: 'entityGlobal.entity.links.view',
            component: LinkView,
            props: true,
            meta: { requiresAuth: true }
        }, {
            path: 'events',
            name: 'entityGlobal.entity.events',
            component: Events,
            meta: { requiresAuth: true }
        }, {
            path: 'contributions',
            name: 'entityGlobal.entity.contributions',
            component: Contributions,
            meta: { requiresAuth: true }
        }, {
            path: 'my-congress',
            name: 'entityGlobal.entity.my-congress',
            component: MyCongress,
            meta: { requiresAuth: true }
        }, {
            path: 'configuration',
            name: 'entityGlobal.entity.config',
            component: Configuration,
            meta: { requiresAuth: true }
        }, {
            path: 'roles',
            name: 'entityGlobal.entity.roles',
            component: EntityRole,
            meta: { requiresAuth: true }
        }]
    }]
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mutations__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__profile__ = __webpack_require__(339);
__webpack_require__(412).polyfill();








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    state: {
        appState: {},
        countries: [],
        comboDateConfigs: {
            format: "YYYY-MM-DD HH:mm:ss",
            template: "D MMM YYYY",
            maxYear: new Date().getFullYear() - 1,
            minYear: new Date().getFullYear() - 100
        }
    },
    getters: {
        App: function App(state) {
            return state.appState;
        },
        authUser: function authUser(state, getters) {
            return getters.App.user;
        },
        countries: function countries(state) {
            return state.countries;
        }
    },
    actions: __WEBPACK_IMPORTED_MODULE_2__actions__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_3__mutations__["a" /* default */],
    modules: {
        profile: __WEBPACK_IMPORTED_MODULE_4__profile__["a" /* default */]
    }
}));

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return messages; });
var messages = window.trans;

/***/ }),

/***/ 266:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(421)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(317),
  /* template */
  __webpack_require__(446),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return upload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(24);


var upload = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'upload';

/***/ }),

/***/ 277:
/***/ (function(module, exports) {

/**
* Combodate - 1.1.0
* Dropdown date and time picker.
* Converts text input into dropdowns to pick day, month, year, hour, minute and second.
* Uses momentjs as datetime library http://momentjs.com.
* For i18n include corresponding file from https://github.com/timrwood/moment/tree/master/lang
*
* Confusion at noon and midnight - see http://en.wikipedia.org/wiki/12-hour_clock#Confusion_at_noon_and_midnight
* In combodate:
* 12:00 pm --> 12:00 (24-h format, midday)
* 12:00 am --> 00:00 (24-h format, midnight, start of day)
*
* Differs from momentjs parse rules:
* 00:00 pm, 12:00 pm --> 12:00 (24-h format, day not change)
* 00:00 am, 12:00 am --> 00:00 (24-h format, day not change)
*
*
* Author: Vitaliy Potapov
* Project page: http://github.com/vitalets/combodate
* Copyright (c) 2012 Vitaliy Potapov. Released under MIT License.
**/
(function ($) {

    var Combodate = function (element, options) {
        this.$element = $(element);
        if(!this.$element.is('input')) {
            $.error('Combodate should be applied to INPUT element');
            return;
        }
        this.options = $.extend({}, $.fn.combodate.defaults, options, this.$element.data());
        this.init();
     };

    Combodate.prototype = {
        constructor: Combodate,
        init: function () {
            this.map = {
                //key   regexp    moment.method
                day:    ['D',    'date'],
                month:  ['M',    'month'],
                year:   ['Y',    'year'],
                hour:   ['[Hh]', 'hours'],
                minute: ['m',    'minutes'],
                second: ['s',    'seconds'],
                ampm:   ['[Aa]', '']
            };

            this.$widget = $('<span class="combodate"></span>').html(this.getTemplate());

            this.initCombos();

            // internal momentjs instance
            this.datetime = null;

            //update original input on change
            this.$widget.on('change', 'select', $.proxy(function(e) {
                this.$element.val(this.getValue()).change();
                // update days count if month or year changes
                if (this.options.smartDays) {
                    if ($(e.target).is('.month') || $(e.target).is('.year')) {
                        this.fillCombo('day');
                    }
                }
            }, this));

            this.$widget.find('select').css('width', 'auto');

            // hide original input and insert widget
            this.$element.hide().after(this.$widget);

            // set initial value
            this.setValue(this.$element.val() || this.options.value);
        },

        /*
         Replace tokens in template with <select> elements
        */
        getTemplate: function() {
            var tpl = this.options.template;
            var inputDisabled = this.$element.prop('disabled');
            var customClass = this.options.customClass;

            //first pass
            $.each(this.map, function(k, v) {
                v = v[0];
                var r = new RegExp(v+'+'),
                    token = v.length > 1 ? v.substring(1, 2) : v;

                tpl = tpl.replace(r, '{'+token+'}');
            });

            //replace spaces with &nbsp;
            tpl = tpl.replace(/ /g, '&nbsp;');

            //second pass
            $.each(this.map, function(k, v) {
                v = v[0];
                var token = v.length > 1 ? v.substring(1, 2) : v;

                tpl = tpl.replace('{'+token+'}', '<select class="'+k+' '+customClass +'"'+
                     (inputDisabled ? ' disabled="disabled"' : '')+'></select>');
            });

            return tpl;
        },

        /*
         Initialize combos that presents in template
        */
        initCombos: function() {
            for (var k in this.map) {
                var $c = this.$widget.find('.'+k);
                // set properties like this.$day, this.$month etc.
                this['$'+k] = $c.length ? $c : null;
                // fill with items
                this.fillCombo(k);
            }
        },

        /*
         Fill combo with items
        */
        fillCombo: function(k) {
            var $combo = this['$'+k];
            if (!$combo) {
                return;
            }

            // define method name to fill items, e.g `fillDays`
            var f = 'fill' + k.charAt(0).toUpperCase() + k.slice(1);
            var items = this[f]();
            var value = $combo.val();

            $combo.empty();
            for(var i=0; i<items.length; i++) {
                $combo.append('<option value="'+items[i][0]+'">'+items[i][1]+'</option>');
            }

            $combo.val(value);
        },

        /*
         Initialize items of combos. Handles `firstItem` option
        */
        fillCommon: function(key) {
            var values = [],
                relTime;

            if(this.options.firstItem === 'name') {
                //need both to support moment ver < 2 and  >= 2
                if (moment.localeData) {
                    relTime = moment.localeData()._relativeTime;
                } else {
                    relTime = moment.relativeTime || moment.langData()._relativeTime;
                }
                var header = typeof relTime[key] === 'function' ? relTime[key](1, true, key, false) : relTime[key];
                //take last entry (see momentjs lang files structure)
                header = header.split(' ').reverse()[0];
                values.push(['', header]);
            } else if(this.options.firstItem === 'empty') {
                values.push(['', '']);
            }
            return values;
        },


        /*
        fill day
        */
        fillDay: function() {
            var items = this.fillCommon('d'), name, i,
                twoDigit = this.options.template.indexOf('DD') !== -1,
                daysCount = 31;

            // detect days count (depends on month and year)
            // originally https://github.com/vitalets/combodate/pull/7
            if (this.options.smartDays && this.$month && this.$year) {
                var month = parseInt(this.$month.val(), 10);
                var year = parseInt(this.$year.val(), 10);

                if (!isNaN(month) && !isNaN(year)) {
                    daysCount = moment([year, month]).daysInMonth();
                }
            }

            for (i = 1; i <= daysCount; i++) {
                name = twoDigit ? this.leadZero(i) : i;
                items.push([i, name]);
            }
            return items;
        },

        /*
        fill month
        */
        fillMonth: function() {
            var items = this.fillCommon('M'), name, i,
                longNamesNum = this.options.template.indexOf('MMMMMM') !== -1,
                shortNamesNum = this.options.template.indexOf('MMMMM') !== -1,
                longNames = this.options.template.indexOf('MMMM') !== -1,
                shortNames = this.options.template.indexOf('MMM') !== -1,
                twoDigit = this.options.template.indexOf('MM') !== -1;

            for(i=0; i<=11; i++) {
                if (longNamesNum) {
                    name = moment().date(1).month(i).format('MM - MMMM');
                } else if (shortNamesNum) {
                    name = moment().date(1).month(i).format('MM - MMM');
                } else if(longNames) {
                    //see https://github.com/timrwood/momentjs.com/pull/36
                    name = moment().date(1).month(i).format('MMMM');
                } else if(shortNames) {
                    name = moment().date(1).month(i).format('MMM');
                } else if(twoDigit) {
                    name = this.leadZero(i+1);
                } else {
                    name = i+1;
                }
                items.push([i, name]);
            }
            return items;
        },

        /*
        fill year
        */
        fillYear: function() {
            var items = [], name, i,
                longNames = this.options.template.indexOf('YYYY') !== -1;

            for(i=this.options.maxYear; i>=this.options.minYear; i--) {
                name = longNames ? i : (i+'').substring(2);
                items[this.options.yearDescending ? 'push' : 'unshift']([i, name]);
            }

            items = this.fillCommon('y').concat(items);

            return items;
        },

        /*
        fill hour
        */
        fillHour: function() {
            var items = this.fillCommon('h'), name, i,
                h12 = this.options.template.indexOf('h') !== -1,
                h24 = this.options.template.indexOf('H') !== -1,
                twoDigit = this.options.template.toLowerCase().indexOf('hh') !== -1,
                min = h12 ? 1 : 0,
                max = h12 ? 12 : 23;

            for(i=min; i<=max; i++) {
                name = twoDigit ? this.leadZero(i) : i;
                items.push([i, name]);
            }
            return items;
        },

        /*
        fill minute
        */
        fillMinute: function() {
            var items = this.fillCommon('m'), name, i,
                twoDigit = this.options.template.indexOf('mm') !== -1;

            for(i=0; i<=59; i+= this.options.minuteStep) {
                name = twoDigit ? this.leadZero(i) : i;
                items.push([i, name]);
            }
            return items;
        },

        /*
        fill second
        */
        fillSecond: function() {
            var items = this.fillCommon('s'), name, i,
                twoDigit = this.options.template.indexOf('ss') !== -1;

            for(i=0; i<=59; i+= this.options.secondStep) {
                name = twoDigit ? this.leadZero(i) : i;
                items.push([i, name]);
            }
            return items;
        },

        /*
        fill ampm
        */
        fillAmpm: function() {
            var ampmL = this.options.template.indexOf('a') !== -1,
                ampmU = this.options.template.indexOf('A') !== -1,
                items = [
                    ['am', ampmL ? 'am' : 'AM'],
                    ['pm', ampmL ? 'pm' : 'PM']
                ];
            return items;
        },

        /*
         Returns current date value from combos.
         If format not specified - `options.format` used.
         If format = `null` - Moment object returned.
        */
        getValue: function(format) {
            var dt, values = {},
                that = this,
                notSelected = false;

            //getting selected values
            $.each(this.map, function(k, v) {
                if(k === 'ampm') {
                    return;
                }

                // if combo exists, use it's value, otherwise use default
                if (that['$'+k]) {
                    values[k] = parseInt(that['$'+k].val(), 10);
                } else {
                    var defaultValue;
                    if (that.datetime) {
                        defaultValue = that.datetime[v[1]]();
                    } else {
                        defaultValue = k === 'day' ? 1 : 0;
                    }
                    values[k] = defaultValue;
                }

                if(isNaN(values[k])) {
                   notSelected = true;
                   return false;
                }
            });

            //if at least one visible combo not selected - return empty string
            if(notSelected) {
               return '';
            }

            //convert hours 12h --> 24h
            if(this.$ampm) {
                //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
                if(values.hour === 12) {
                    values.hour = this.$ampm.val() === 'am' ? 0 : 12;
                } else {
                    values.hour = this.$ampm.val() === 'am' ? values.hour : values.hour+12;
                }
            }

            dt = moment([
                values.year,
                values.month,
                values.day,
                values.hour,
                values.minute,
                values.second
            ]);

            //highlight invalid date
            this.highlight(dt);

            format = format === undefined ? this.options.format : format;
            if(format === null) {
               return dt.isValid() ? dt : null;
            } else {
               return dt.isValid() ? dt.format(format) : '';
            }
        },

        setValue: function(value) {
            if(!value) {
                return;
            }

            // parse in strict mode (third param `true`)
            var dt = typeof value === 'string' ? moment(value, this.options.format, true) : moment(value),
                that = this,
                values = {};

            //function to find nearest value in select options
            function getNearest($select, value) {
                var delta = {};
                $select.children('option').each(function(i, opt){
                    var optValue = $(opt).attr('value'),
                    distance;

                    if(optValue === '') return;
                    distance = Math.abs(optValue - value);
                    if(typeof delta.distance === 'undefined' || distance < delta.distance) {
                        delta = {value: optValue, distance: distance};
                    }
                });
                return delta.value;
            }

            if(dt.isValid()) {
                //read values from date object
                $.each(this.map, function(k, v) {
                    if(k === 'ampm') {
                       return;
                    }
                    values[k] = dt[v[1]]();
                });

                if(this.$ampm) {
                    //12:00 pm --> 12:00 (24-h format, midday), 12:00 am --> 00:00 (24-h format, midnight, start of day)
                    if(values.hour >= 12) {
                        values.ampm = 'pm';
                        if(values.hour > 12) {
                            values.hour -= 12;
                        }
                    } else {
                        values.ampm = 'am';
                        if(values.hour === 0) {
                            values.hour = 12;
                        }
                    }
                }

                $.each(values, function(k, v) {
                    //call val() for each existing combo, e.g. this.$hour.val()
                    if(that['$'+k]) {

                        if(k === 'minute' && that.options.minuteStep > 1 && that.options.roundTime) {
                           v = getNearest(that['$'+k], v);
                        }

                        if(k === 'second' && that.options.secondStep > 1 && that.options.roundTime) {
                           v = getNearest(that['$'+k], v);
                        }

                        that['$'+k].val(v);
                    }
                });

                // update days count
                if (this.options.smartDays) {
                    this.fillCombo('day');
                }

                this.$element.val(dt.format(this.options.format)).change();
                this.datetime = dt;
            } else {
                this.datetime = null;
            }
        },

        /*
         highlight combos if date is invalid
        */
        highlight: function(dt) {
            if(!dt.isValid()) {
                if(this.options.errorClass) {
                    this.$widget.addClass(this.options.errorClass);
                } else {
                    //store original border color
                    if(!this.borderColor) {
                        this.borderColor = this.$widget.find('select').css('border-color');
                    }
                    this.$widget.find('select').css('border-color', 'red');
                }
            } else {
                if(this.options.errorClass) {
                    this.$widget.removeClass(this.options.errorClass);
                } else {
                    this.$widget.find('select').css('border-color', this.borderColor);
                }
            }
        },

        leadZero: function(v) {
            return v <= 9 ? '0' + v : v;
        },

        destroy: function() {
            this.$widget.remove();
            this.$element.removeData('combodate').show();
        }

        //todo: clear method
    };

    $.fn.combodate = function ( option ) {
        var d, args = Array.apply(null, arguments);
        args.shift();

        //getValue returns date as string / object (not jQuery object)
        if(option === 'getValue' && this.length && (d = this.eq(0).data('combodate'))) {
          return d.getValue.apply(d, args);
        }

        return this.each(function () {
            var $this = $(this),
            data = $this.data('combodate'),
            options = typeof option == 'object' && option;
            if (!data) {
                $this.data('combodate', (data = new Combodate(this, options)));
            }
            if (typeof option == 'string' && typeof data[option] == 'function') {
                data[option].apply(data, args);
            }
        });
    };

    $.fn.combodate.defaults = {
         //in this format value stored in original input
        format: 'DD-MM-YYYY HH:mm',
        //in this format items in dropdowns are displayed
        template: 'D / MMM / YYYY   H : mm',
        //initial value, can be `new Date()`
        value: null,
        minYear: 1970,
        maxYear: 2015,
        yearDescending: true,
        minuteStep: 5,
        secondStep: 1,
        firstItem: 'empty', //'name', 'empty', 'none'
        errorClass: null,
        customClass: '',
        roundTime: true, // whether to round minutes and seconds if step > 1
        smartDays: false // whether days in combo depend on selected month: 31, 30, 28
    };

}(window.jQuery));

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_commons_Header__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_commons_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_commons_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_commons_Footer__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_commons_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_commons_Footer__);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app',
    components: {
        "navbar": __WEBPACK_IMPORTED_MODULE_0__components_commons_Header___default.a,
        Foot: __WEBPACK_IMPORTED_MODULE_1__components_commons_Footer___default.a
    },
    data: function data() {
        return {
            api: api_routes,
            user: $auth.getUser()
        };
    },


    methods: {
        guard: function guard() {
            var _this = this;

            var access_token = window.location.hash.match(/[?#]access_token=([^&]*)?/);
            access_token = access_token == null ? "" : access_token[1] || "";

            if (access_token && !$auth.checkAuth()) {
                $auth.authUser(this, access_token, function (response) {
                    if (response.status) {
                        Event.$emit('userAuthorized');

                        var redirectUrl = localStorage.getItem('redirectUrl');

                        localStorage.removeItem('redirectUrl');

                        if (redirectUrl) {
                            _this.$router.push({
                                path: redirectUrl
                            });
                        } else {
                            _this.$router.push({ name: 'dashboard' });
                        }
                    } else {
                        console.log(response);
                    }
                });
            }
        }
    },

    mounted: function mounted() {
        var _this2 = this;

        this.guard();

        Event.$on('userAuthorized', function () {
            methods.setDefaultBearer();
            _this2.user = $auth.getUser();
            localStorage.removeItem('communityId');
        });

        Event.$on('userLoggedOutAction', function () {
            var route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

            $auth.logout();
            _this2.user = false;

            if (route.params.entity_id) {
                localStorage.setItem('communityId', route.params.entity_id);
            }

            localStorage.setItem('redirectUrl', route.fullPath);

            _this2.$router.push({ name: 'login' });
        });
    },
    created: function created() {
        Event.$on('set_title', function (title) {
            document.title = title + " - " + window.config.APP_NAME;
        });
    }
});

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Footer',
    data: function data() {
        return {
            appTitle: window.APP_NAME,
            footerText: window.footerConfig.footer_text,
            footer_logo: window.footerConfig.footer_logo
        };
    }
});

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'Header',
    props: ['user'],
    data: function data() {
        return {
            backgroundColor: null,
            fontColor: null,
            appName: window.APP_NAME
        };
    },

    computed: {
        profileLink: function profileLink() {
            return window.API_DOMAIN + '/profiles/' + this.user.id;
        }
    },
    watch: {
        '$route.params': function $routeParams() {
            if (!this.$route.params.entity_id) {
                this.backgroundColor = null;
                this.fontColor = null;
            }
        }
    },
    methods: {
        logout: function logout() {
            Event.$emit('userLoggedOutAction', this.$route);
        }
    },
    mounted: function mounted() {
        var _this = this;

        Event.$on('update-header-color', function (backgroundColorCode, fontColorCode) {
            _this.backgroundColor = {
                backgroundColor: backgroundColorCode
            };

            _this.fontColor = {
                color: fontColorCode
            };
        });
    }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'login',
    props: ['api'],
    data: function data() {
        return {
            msg: 'Hello There',
            context: 'oauth2 context',
            type: 'sensa',
            loginConfig: window.loginConfig,
            sensaProvider: {
                clientId: config.APP_ID,
                url: config.AUTH_URL,
                redirect: config.REDIRET,
                scope: '',
                responseType: 'token',
                state: {}
            },
            featuredImage: window.loginConfig.featuredImage,
            logo: window.loginConfig.logo,
            title: window.loginConfig.communityName,
            subTitle: window.loginConfig.subtitle,
            buttonText: window.loginConfig.loginButtonText,
            footerText: window.footerConfig.footer_text,
            loading: true
        };
    },
    mounted: function mounted() {
        Event.$emit('set_title', 'Login');
        Event.$emit('endLoading');
    },


    methods: {
        makeLogin: function makeLogin(type) {
            $auth.performOauth2Authorize(this.sensaProvider);
        },
        setImages: function setImages() {
            var _this = this;

            var communityId = localStorage.getItem('communityId');

            if (communityId) {
                axios.get(this.api.findCommunity(communityId)).then(function (response) {
                    if (response.data.cover_photo) {
                        _this.featuredImage = response.data.cover_photo;
                    }

                    if (response.data.logo) {
                        _this.logo = response.data.logo;
                    }

                    _this.title = response.data.title;

                    _this.subTitle = response.data.description;

                    _this.loading = false;
                }).catch(function (error) {});
            } else {
                this.loading = false;
            }
        }
    },
    created: function created() {
        this.setImages();
        Event.$emit('set_title', window.config.APP_NAME);
        Event.$emit('endLoading');
    }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(25);



var ENTITIES = 'entities/';

/* harmony default export */ __webpack_exports__["a"] = ({
    entities: function entities() {
        var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var params = arguments[1];

        return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ENTITIES + (id || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    findCommunity: function findCommunity(id) {
        return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'search/entity-names/' + id;
    },


    entityTypes: __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'options?fields=entityTypes',

    leaderships: function leaderships(entityId, params) {
        var entity = this.entities(entityId);

        return entity + '/leaderships/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    leaders: function leaders(entityId) {
        var leaderId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var params = arguments[2];

        var entity = this.entities(entityId);

        return entity + '/leaders/' + (leaderId ? leaderId : '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    memberships: function memberships(entityId, params) {
        var entity = this.entities(entityId);

        return entity + '/memberships/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    members: function members(entityId, params) {
        var entity = this.entities(entityId);

        return entity + '/profiles/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    exportMembers: function exportMembers(entityId, params) {
        var entity = this.entities(entityId);

        return entity + '/profiles/export' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    announcements: function announcements(entityId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/announcements/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    announcement: function announcement(entityId, announcement_id, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/announcements/' + announcement_id + '/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    announcementMeta: function announcementMeta(entityId, announcement_id, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/announcements/' + announcement_id + '/meta' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    announcementSync: function announcementSync(entityId, announcement_id, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/announcements/' + announcement_id + '/subscribers/sync' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityRoles: function entityRoles(entityId, params) {
        var entity = this.entities(entityId);
        return entity + '/roles/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityRole: function entityRole(entityId, role_id, params) {
        var entity = this.entities(entityId);
        return entity + '/roles/' + role_id + '/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityRoleTypes: function entityRoleTypes(entityId) {
        var entity = this.entities(entityId);

        return entity + '/role-types/';
    },
    entityPhones: function entityPhones(entityId, params) {
        var entity = this.entities(entityId);
        return entity + '/phones/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityEmails: function entityEmails(entityId, params) {
        var entity = this.entities(entityId);
        return entity + '/emails/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityAddresses: function entityAddresses(entityId, params) {
        var entity = this.entities(entityId);
        return entity + '/addresses/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityLinks: function entityLinks(entityId, linkId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/links/' + (linkId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityAlbums: function entityAlbums(entityId, albumsId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/albums/' + (albumsId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityAlbumPhotos: function entityAlbumPhotos(entityId, albumsId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/albums/' + albumsId + '/photos' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityAlbumPhoto: function entityAlbumPhoto(entityId, albumsId, photo_id, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/albums/' + albumsId + '/photos/' + photo_id + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityPhotos: function entityPhotos(entityId, photoId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/links/' + (photoId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityVideos: function entityVideos(entityId, videoId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/videos/' + (videoId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityDocs: function entityDocs(entityId, docId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/documents/' + (docId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityAudios: function entityAudios(entityId, audioId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/audios/' + (audioId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityNotes: function entityNotes(entityId, noteId, params) {
        var entity = this.entities(entityId);
        return entity + '/resource/notes/' + (noteId || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entitySystemRoles: function entitySystemRoles(id, params) {
        return this.entities(id) + '/system-roles' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entitySystemRole: function entitySystemRole(entityId, id, params) {
        return this.entities(entityId) + '/system-roles/' + id + '/search-available-members' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    entityProfiles: function entityProfiles(id, params) {
        return this.entities(id) + '/profiles' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    },
    approveJoin: function approveJoin(id) {
        return this.entities(id) + '/approve-join-request';
    },
    declineJoin: function declineJoin(id) {
        return this.entities(id) + '/decline-join-request';
    },
    entityNewProfile: function entityNewProfile(id) {
        return this.entities(id) + '/new-profiles';
    }
});

/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export login */
/* unused harmony export register */
/* unused harmony export passwordEmail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(24);


var login = '/login';

var register = '/register';

var passwordEmail = __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'password/email';

/* harmony default export */ __webpack_exports__["a"] = ({
    login: login,
    register: register,
    passwordEmail: passwordEmail
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

/* harmony default export */ __webpack_exports__["a"] = ({
    getOauthUser: function getOauthUser() {
        if (localStorage.getItem('user')) return JSON.parse(localStorage.getItem('user'));
        return false;
    },
    setOauthUser: function setOauthUser(user) {
        localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(user));
    },
    removeOauthUser: function removeOauthUser() {
        localStorage.removeItem('user');
    },
    clearUserResource: function clearUserResource() {
        this.removeOauthUser();

        this.removeToken();

        this.authenticated = false;
    },
    fetchUser: function fetchUser(context, url, callback) {
        var _this = this;

        axios.get(url, {
            headers: this.authHeader()
        }).then(function (data) {
            var user = data.data;

            _this.setOauthUser(user);

            return _this.processSuccess({ user: user, status: true }, callback);
        }, function (error) {
            _this.clearUserResource();
            return _this.processError({
                error: error,
                status: false
            }, callback);
        });
    },
    processSuccess: function processSuccess(response, callback) {

        if (typeof callback === 'function') {
            return callback(response);
        }
    },
    processError: function processError(response, callback) {

        if (typeof callback === 'function') {
            return callback(response);
        }
    },


    getToken: function getToken() {
        return localStorage.getItem('id_token');
    },

    setToken: function setToken(token) {
        localStorage.setItem('id_token', token);
    },
    removeToken: function removeToken() {
        localStorage.removeItem('id_token');
    },
    authHeader: function authHeader() {
        return {
            Accept: 'application/json',
            Authorization: 'Bearer ' + this.getToken()
        };
    }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_i18n__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_api_routes__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue2_google_maps__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_event_calendar_dist_style_css__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_event_calendar_dist_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_event_calendar_dist_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_event_calendar__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_event_calendar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_event_calendar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__env__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__libs_authService__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__translations__ = __webpack_require__(261);

















__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue2_google_maps__, {
    load: {
        key: 'AIzaSyBXXzerxH5r2GahWzWegy30Elh_K8z__V8',
        v: '3.27',
        libraries: 'places' },
    installComponents: true
});



__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_event_calendar___default.a, { locale: 'en' });

window.config = __WEBPACK_IMPORTED_MODULE_16__env__["a" /* default */];

window.$auth = __WEBPACK_IMPORTED_MODULE_17__libs_authService__["a" /* default */];

global.Event = new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]();
global.jQuery = global.$ = __WEBPACK_IMPORTED_MODULE_3_jquery___default.a;
global.lodash = global._ = __WEBPACK_IMPORTED_MODULE_5_lodash___default.a;
global.axios = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;
global.moment = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;
global.Vue = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];
global.api_routes = __WEBPACK_IMPORTED_MODULE_12__api_api_routes__["a" /* default */];

global.Errors = function () {
    function Errors() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Errors);

        this.errors = {};
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Errors, [{
        key: 'get',
        value: function get(field) {
            if (this.errors[field]) {
                return this.errors[field][0];
            }
        }
    }, {
        key: 'has',
        value: function has(field) {
            return !!this.errors[field];
        }
    }, {
        key: 'record',
        value: function record(errors) {
            this.errors = errors;
        }
    }, {
        key: 'clear',
        value: function clear(field) {
            if (field) {
                this.errors[field] = null;
            } else {
                this.errors = {};
            }
        }
    }]);

    return Errors;
}();

global.methods = {
    dateFormat: function dateFormat(date, format) {
        var dateString = date === undefined ? null : date;
        var dateObj = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateString);

        return dateObj.isValid() ? dateObj.format(format) : null;
    },
    setDefaultBearer: function setDefaultBearer() {
        __WEBPACK_IMPORTED_MODULE_4_axios___default.a.defaults.headers.common = this.getReqHeaders();
    },
    getReqHeaders: function getReqHeaders() {
        return {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('id_token')
        };
    },
    isValidURL: function isValidURL(url) {
        return url.match(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/g);
    },
    beforeUpload: function beforeUpload(ctx, file) {
        var isJPG = file.type === 'image/jpeg';
        var isPNG = file.type === 'image/png';
        var isLt2M = file.size / 1024 / 1024 < 2;

        var isImage = false;
        if (isJPG) isImage = true;
        if (isPNG) isImage = true;

        if (!isImage) {
            ctx.$message.error('Image must be JPG or PNG format!');
        }

        if (!isLt2M) {
            ctx.$message.error('Image size can not exceed 2MB!');
        }

        return isImage && isLt2M;
    },
    hasPermission: function hasPermission(data, permission) {
        if (data) {
            if (data.superman) {
                return true;
            }

            return data.permissions.indexOf(permission) != -1;
        }

        return false;
    }
};

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].filter('dateFormat', function (date, format) {
    return methods.dateFormat(date, format);
});

methods.setDefaultBearer();


__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_18_element_ui_lib_locale_lang_en___default.a });
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]);


var i18n = new __WEBPACK_IMPORTED_MODULE_8_vue_i18n__["a" /* default */]({
    locale: 'en',
    messages: __WEBPACK_IMPORTED_MODULE_19__translations__["a" /* messages */],
    silentTranslationWarn: true
});

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__webpack_require__(255);

var mixin = {
    methods: {
        responsiveDialogSize: function responsiveDialogSize() {
            var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'small';

            var defaultSize = size;
            if (window.innerWidth < 481) defaultSize = 'full';

            return defaultSize;
        },
        isResponsive: function isResponsive(width) {
            if (window.innerWidth <= width) return true;
            return false;
        },
        hasPermission: function hasPermission(data, permission) {
            if (data) {
                if (data.superman) {
                    return true;
                }
                return data.permissions.indexOf(permission) != -1;
            }
            return false;
        },
        buildRoute: function buildRoute(name) {
            var isGlobal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return isGlobal ? 'entityGlobal.' + name : name;
        }
    }
};
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].mixin(mixin);

__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].beforeEach(function (to, from, next) {
    Event.$emit('startLoading');

    $(window).scrollTop(0);

    if (to.meta.requiresAuth && !$auth.checkAuth()) {
        localStorage.setItem('redirectUrl', to.fullPath);

        if (to.params.entity_id) {
            localStorage.setItem('communityId', to.params.entity_id);
        }

        next({
            name: 'login',
            query: { redirect: to.fullPath }
        });
    } else {
        if (to.name === 'login' && $auth.checkAuth()) {
            next({ name: 'dashboard' });
        }

        next();
    }
});

__webpack_require__(257);

new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */],
    mixins: [mixin],
    store: __WEBPACK_IMPORTED_MODULE_11__store__["a" /* default */],
    i18n: i18n,
    template: '<App/>',
    components: { App: __WEBPACK_IMPORTED_MODULE_9__App___default.a }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(19)))

/***/ }),

/***/ 330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(25);


/* harmony default export */ __webpack_exports__["a"] = ({
    getCountries: function getCountries(_ref) {
        var commit = _ref.commit;

        var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getOptions */])('countries');

        axios.get(requestUrl).then(function (response) {
            commit('getCountries', response.data.countries);
        }).catch(function (error) {});
    }
});

/***/ }),

/***/ 331:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    getCountries: function getCountries(state, payload) {
        state.countries = payload;
    }
});

/***/ }),

/***/ 332:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_profile__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
    getProfileSections: function getProfileSections(_ref) {
        var commit = _ref.commit,
            rootGetters = _ref.rootGetters;

        commit('getProfileSections', rootGetters.App.profileSections);
    },
    getProfileOptions: function getProfileOptions(_ref2, includes) {
        var commit = _ref2.commit;

        var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* getOptions */])(includes);

        axios.get(requestUrl).then(function (response) {
            commit('getProfileOptions', response.data);
        }).catch(function (error) {});
    },
    getProfile: function getProfile(_ref3) {
        var commit = _ref3.commit,
            rootGetters = _ref3.rootGetters;
        var collectionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        var profileId = rootGetters['profile/memberId'];
        var entityId = rootGetters['profile/entityId'];
        var requestUrl = __WEBPACK_IMPORTED_MODULE_2__api_profile__["n" /* default */].basicInfo(entityId, profileId);

        if (collectionId) {
            requestUrl += "?includeChildEntityMembers=true&collectionId=" + collectionId;
        }

        axios.get(requestUrl).then(function (response) {
            commit('getProfile', response.data);
        });
    },
    uploadAvatar: function uploadAvatar(_ref4, photoUrl) {
        var commit = _ref4.commit,
            rootGetters = _ref4.rootGetters;

        var profileId = rootGetters['profile/memberId'];
        var entityId = rootGetters['profile/entityId'];

        var requestUrl = __WEBPACK_IMPORTED_MODULE_2__api_profile__["n" /* default */].basicInfo(entityId, profileId);
        var photoObj = {
            profile_photo_large: photoUrl
        };

        axios.put(requestUrl, photoObj).then(function (response) {
            commit('updateAvatar', response.data.user.profile_photo_large);
        }).catch(function (e) {
            console.log(e.response);
        });
    },
    removeConfirmation: function removeConfirmation(_ref5, removeableItem) {
        var state = _ref5.state,
            commit = _ref5.commit,
            rootGetters = _ref5.rootGetters;

        var profileId = rootGetters['profile/memberId'],
            removeableItemKey = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(removeableItem)[0],
            removeableItemSlug = void 0,
            removeableItemId = removeableItem[removeableItemKey].id,
            removeableItemStateKey = void 0;

        switch (removeableItemKey) {
            case 'phone':
                removeableItemSlug = 'phones';
                removeableItemStateKey = 'contactPhoneState';
                break;

            case 'email':
                removeableItemSlug = 'emails';
                removeableItemStateKey = 'contactEmailState';
                break;

            case 'address':
                removeableItemSlug = 'addresses';
                removeableItemStateKey = 'contactAddressState';
                break;

            case 'citizenships':
                removeableItemSlug = 'citizenships';
                removeableItemStateKey = 'citizenshipState';
                break;

            case 'employment':
                removeableItemSlug = 'employments';
                removeableItemStateKey = 'employmentState';
                break;

            case 'membership':
                removeableItemSlug = 'memberships';
                removeableItemStateKey = 'membershipState';
                break;

            case 'education':
                removeableItemSlug = 'educations';
                removeableItemStateKey = 'educationState';
                break;

            case 'skill':
                removeableItemSlug = 'skills';
                removeableItemStateKey = 'skillState';
                break;

            case 'socialMedia':
                removeableItemSlug = 'socialMedia';
                removeableItemStateKey = 'socialMediaState';
                break;
        }

        var requestUrl = __WEBPACK_IMPORTED_MODULE_2__api_profile__["n" /* default */][removeableItemSlug](profileId);
        requestUrl += '/' + removeableItemId;

        var promise = axios.delete(requestUrl);

        promise.then(function () {
            commit('removeConfirmation', {
                removeableItemSlug: removeableItemSlug,
                removeableItemStateKey: removeableItemStateKey,
                data: removeableItem[removeableItemKey]
            });
        });

        return promise;
    }
});

/***/ }),

/***/ 333:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    setProfileId: function setProfileId(state, id) {
        state.memberId = id;
    },
    setEntityId: function setEntityId(state, id) {
        state.entityId = id;
    },
    getProfileSections: function getProfileSections(state, payload) {},
    getProfileOptions: function getProfileOptions(state, options) {
        state.profileOptions = options;
    },
    getProfile: function getProfile(state, profile) {
        state.profileState = profile;
    },
    updateAvatar: function updateAvatar(state, payload) {
        state.profileState.profile_photo_large = payload;
    },
    saveBasicInfo: function saveBasicInfo(state, user) {
        state.profileState = user;
    },
    removeConfirmation: function removeConfirmation(state, _ref) {
        var removeableItemSlug = _ref.removeableItemSlug,
            removeableItemStateKey = _ref.removeableItemStateKey,
            data = _ref.data;

        var removeableItemState;
        if (removeableItemStateKey === 'contactPhoneState' || removeableItemStateKey === 'contactEmailState' || removeableItemStateKey === 'contactAddressState') {
            removeableItemState = state.contact[removeableItemStateKey];
        } else {
            removeableItemState = state[removeableItemSlug][removeableItemStateKey];
        }

        removeableItemState.splice(removeableItemState.indexOf(data), 1);
    }
});

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {},
    getters: {},
    mutations: {},
    actions: {
        saveBasicInfo: function saveBasicInfo(_ref, updateUser) {
            var commit = _ref.commit,
                rootGetters = _ref.rootGetters;

            var profileId = rootGetters['profile/memberId'];
            var entityId = rootGetters['profile/entityId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["m" /* basicInfo */])(entityId, profileId);
            var promise = axios.put(requestUrl, updateUser);

            promise.then(function (response) {
                commit('saveBasicInfo', response.data.user);
            }).catch(function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 335:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        citizenshipState: null
    },
    getters: {
        citizenships: function citizenships(state) {
            return state.citizenshipState;
        }
    },
    mutations: {
        saveCitizenship: function saveCitizenship(state, payload) {
            var stateRef = state.citizenshipState;

            if (payload.editId) {
                var record = stateRef.find(function (item) {
                    return item.id === payload.editId;
                });
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData);
            } else {
                stateRef.push(payload.newData);
            }
        },
        getCitizenships: function getCitizenships(state, payload) {
            state.citizenshipState = payload;
        }
    },
    actions: {
        saveCitizenship: function saveCitizenship(_ref, formData) {
            var commit = _ref.commit,
                rootGetters = _ref.rootGetters;


            var profileId = rootGetters['profile/memberId'],
                entityid = rootGetters['profile/entityId'],
                requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["h" /* citizenships */])(entityid, profileId),
                requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newCitizenship);

            promise.then(function (response) {
                commit('saveCitizenship', {
                    editId: formData.editId,
                    newData: response.data.citizenship
                });
            }, function (error) {});

            return promise;
        },
        getCitizenships: function getCitizenships(_ref2) {
            var state = _ref2.state,
                commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.citizenshipState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["h" /* citizenships */])(entityId, profileId)).then(function (response) {
                    commit('getCitizenships', response.data.citizenships);
                }).catch(function () {});
            }
        }
    }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        contactEmailState: {},
        contactPhoneState: {},
        contactAddressState: {}
    },
    getters: {
        contactEmails: function contactEmails(state) {
            return state.contactEmailState;
        },
        contactPhones: function contactPhones(state) {
            return state.contactPhoneState;
        },
        contactAddresses: function contactAddresses(state) {
            return state.contactAddressState;
        }
    },
    mutations: {
        getContactInfo: function getContactInfo(state, payload) {
            state.contactEmailState = payload.emails;
            state.contactPhoneState = payload.phones;
            state.contactAddressState = payload.addresses;
        },
        saveEmail: function saveEmail(state, payload) {
            var stateRef = state.contactEmailState;
            if (payload.editId) {
                var record = stateRef.find(function (item) {
                    return item.id === payload.editId;
                });
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData);
            } else {
                stateRef.push(payload.newData);
            }
        },
        savePhone: function savePhone(state, payload) {
            var stateRef = state.contactPhoneState;
            if (payload.editId) {
                var record = stateRef.find(function (item) {
                    return item.id === payload.editId;
                });
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData);
            } else {
                stateRef.push(payload.newData);
            }
        },
        saveAddress: function saveAddress(state, payload) {
            var stateRef = state.contactAddressState;
            if (payload.editId) {
                var record = stateRef.find(function (item) {
                    return item.id === payload.editId;
                });
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData);
            } else {
                stateRef.push(payload.newData);
            }
        }
    },

    actions: {
        getContactInfo: function getContactInfo(_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                rootGetters = _ref.rootGetters;

            var entityId = rootGetters['profile/entityId'];
            var profileId = rootGetters['profile/memberId'];

            if (_.isEmpty(state.contactState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["i" /* getContacts */])(entityId, profileId)).then(function (response) {
                    commit('getContactInfo', response.data);
                });
            }
        },
        saveEmail: function saveEmail(_ref2, formData) {
            var commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var entityId = rootGetters['profile/entityId'];
            var profileId = rootGetters['profile/memberId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["j" /* emails */])(entityId, profileId);
            var requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newData);

            promise.then(function (response) {
                commit('saveEmail', {
                    editId: formData.editId,
                    newData: response.data.email
                });
            }, function (error) {});

            return promise;
        },
        savePhone: function savePhone(_ref3, formData) {
            var commit = _ref3.commit,
                rootGetters = _ref3.rootGetters;

            var entityId = rootGetters['profile/entityId'];
            var profileId = rootGetters['profile/memberId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["k" /* phones */])(entityId, profileId);
            var requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newData);

            promise.then(function (response) {
                commit('savePhone', {
                    editId: formData.editId,
                    newData: response.data.phone
                });
            }, function (error) {});

            return promise;
        },
        saveAddress: function saveAddress(_ref4, formData) {
            var commit = _ref4.commit,
                rootGetters = _ref4.rootGetters;

            var entityId = rootGetters['profile/entityId'];
            var profileId = rootGetters['profile/memberId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["l" /* addresses */])(entityId, profileId);
            var requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newData);

            promise.then(function (response) {
                commit('saveAddress', {
                    editId: formData.editId,
                    newData: response.data.address
                });
            }, function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        educationState: null
    },

    getters: {
        educations: function educations(state) {
            return state.educationState;
        }
    },

    mutations: {
        getEducations: function getEducations(state, payload) {
            state.educationState = payload;
        },
        saveEducation: function saveEducation(state, payload) {
            var stateRef = state.educationState;

            if (payload.editId) {
                var record = stateRef.find(function (item) {
                    return item.id === payload.editId;
                });
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData);
            } else {
                stateRef.push(payload.newData);
            }
        }
    },

    actions: {
        getEducations: function getEducations(_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                rootGetters = _ref.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.educationState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["e" /* educations */])(entityId, profileId)).then(function (response) {
                    commit('getEducations', response.data.education);
                }).catch(function () {});
            }
        },
        saveEducation: function saveEducation(_ref2, formData) {
            var commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["e" /* educations */])(entityId, profileId);
            var requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newEducation);

            promise.then(function (response) {
                commit('saveEducation', {
                    editId: formData.editId,
                    newData: response.data.education
                });
            }).catch(function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        employmentState: null
    },

    getters: {
        employments: function employments(state) {
            return state.employmentState;
        }
    },

    mutations: {
        getEmployments: function getEmployments(state, payload) {
            state.employmentState = payload;
        },
        saveEmployment: function saveEmployment(state, payload) {
            var employmentState = state.employmentState;

            if (payload.editId) {
                var record = employmentState.find(function (item) {
                    return item.id === payload.editId;
                });
                employmentState.splice(employmentState.indexOf(record), 1, payload.newEmployment);
            } else {
                employmentState.push(payload.newEmployment);
            }
        }
    },

    actions: {
        getEmployments: function getEmployments(_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                rootGetters = _ref.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.employmentState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["g" /* employments */])(entityId, profileId)).then(function (response) {
                    commit('getEmployments', response.data.employments);
                }, function (error) {});
            }
        },
        saveEmployment: function saveEmployment(_ref2, formData) {
            var commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'],
                requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["g" /* employments */])(entityId, profileId),
                requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newEmployment);

            promise.then(function (response) {
                commit('saveEmployment', {
                    editId: formData.editId,
                    newEmployment: response.data.employment
                });
            }, function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutations__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__about__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__contact__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__citizenships__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__employments__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__educations__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__memberships__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__skills__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__socials__ = __webpack_require__(342);












/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        memberId: false,
        entityId: false,
        profileState: {},
        profileSections: {
            about: 'About',
            contact: 'contact',
            citizenships: 'citizenship',

            memberships: 'memberships',
            employments: 'employment',
            educations: 'education',
            skills: 'skills',
            socials: 'social'
        },
        profileOptions: {},
        countries: {}
    },
    getters: {
        basicInfo: function basicInfo(state) {
            return state.profileState;
        },
        memberId: function memberId(state) {
            return state.memberId;
        },
        entityId: function entityId(state) {
            return state.entityId;
        },
        profileSections: function profileSections(state) {
            return state.profileSections;
        },
        profileOptions: function profileOptions(state) {
            return state.profileOptions;
        },
        countries: function countries(state) {
            return state.countries;
        }
    },
    actions: __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */],
    mutations: __WEBPACK_IMPORTED_MODULE_1__mutations__["a" /* default */],
    modules: {
        about: __WEBPACK_IMPORTED_MODULE_2__about__["a" /* default */],
        contact: __WEBPACK_IMPORTED_MODULE_3__contact__["a" /* default */],
        citizenships: __WEBPACK_IMPORTED_MODULE_4__citizenships__["a" /* default */],
        employments: __WEBPACK_IMPORTED_MODULE_5__employments__["a" /* default */],
        memberships: __WEBPACK_IMPORTED_MODULE_7__memberships__["a" /* default */],
        educations: __WEBPACK_IMPORTED_MODULE_6__educations__["a" /* default */],
        skills: __WEBPACK_IMPORTED_MODULE_8__skills__["a" /* default */],
        socialMedia: __WEBPACK_IMPORTED_MODULE_9__socials__["a" /* default */]
    }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        membershipState: null
    },

    getters: {
        memberships: function memberships(state) {
            return state.membershipState;
        }
    },

    mutations: {
        getMemberships: function getMemberships(state, payload) {
            state.membershipState = payload;
        },
        saveMembership: function saveMembership(state, payload) {
            var membershipState = state.membershipState;

            if (payload.editId) {
                var record = membershipState.find(function (item) {
                    return item.id === payload.editId;
                });
                membershipState.splice(membershipState.indexOf(record), 1, payload.newMembership);
            } else {
                membershipState.push(payload.newMembership);
            }
        }
    },

    actions: {
        getMemberships: function getMemberships(_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                rootGetters = _ref.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.entityState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["f" /* memberships */])(entityId, profileId)).then(function (response) {
                    commit('getMemberships', response.data.memberships);
                }).catch(function (error) {});
            }
        },
        saveMembership: function saveMembership(_ref2, formData) {
            var commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["f" /* memberships */])(profileId),
                requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newMembership);

            promise.then(function (response) {
                commit('saveMembership', {
                    editId: formData.editId,
                    newMembership: response.data.membership
                });
            }, function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: false,
    state: {
        skillState: null
    },

    getters: {
        skills: function skills(state) {
            return state.skillState;
        }
    },

    mutations: {
        getSkills: function getSkills(state, payload) {
            state.skillState = payload;
        },
        saveSkill: function saveSkill(state, payload) {
            var skillState = state.skillState;

            if (payload.editId) {
                var record = skillState.find(function (item) {
                    return item.id === payload.editId;
                });
                skillState.splice(skillState.indexOf(record), 1, payload.newSkill);
            } else {
                skillState.push(payload.newSkill);
            }
        },
        saveCertification: function saveCertification(state, payload) {
            var certificationBySkill = state.skillState.find(function (item) {
                return item.id === payload.skill_id;
            });
            certificationBySkill.certifications.push(payload);
        },
        saveGroup: function saveGroup(state, payload) {
            var groupBySkill = state.skillState.find(function (item) {
                return item.id === payload.skillId;
            });
            groupBySkill.professionalGroups.push(payload.newGroup);
        }
    },

    actions: {
        getSkills: function getSkills(_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                rootGetters = _ref.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.skillState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["b" /* skills */])(entityId, profileId)).then(function (response) {
                    commit('getSkills', response.data.skills);
                }).catch(function () {});
            }
        },
        saveSkill: function saveSkill(_ref2, formData) {
            var commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'],
                requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["b" /* skills */])(entityId, profileId),
                requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newSkill);

            promise.then(function (response) {
                commit('saveSkill', {
                    editId: formData.editId,
                    newSkill: response.data.skill
                });
            }, function (error) {});

            return promise;
        },
        saveCertification: function saveCertification(_ref3, _ref4) {
            var commit = _ref3.commit,
                rootGetters = _ref3.rootGetters;
            var skillId = _ref4.skillId,
                newCertification = _ref4.newCertification;

            var profileId = rootGetters['profile/memberId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["c" /* certifications */])(profileId, skillId);

            var promise = axios.post(requestUrl, newCertification);

            promise.then(function (response) {
                commit('saveCertification', response.data.certification);
            }, function (error) {});

            return promise;
        },
        saveGroup: function saveGroup(_ref5, _ref6) {
            var commit = _ref5.commit,
                rootGetters = _ref5.rootGetters;
            var skillId = _ref6.skillId,
                newGroup = _ref6.newGroup;

            var profileId = rootGetters['profile/memberId'];
            var requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["d" /* groups */])(profileId, skillId);

            var promise = axios.post(requestUrl, newGroup);

            promise.then(function (response) {
                console.log(response.data);
                commit('saveGroup', { skillId: skillId, newGroup: newGroup });
            }).catch(function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 342:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_profile__ = __webpack_require__(7);


/* harmony default export */ __webpack_exports__["a"] = ({
    state: {
        socialMediaState: null
    },

    getters: {
        socialMedia: function socialMedia(state) {
            return state.socialMediaState;
        }
    },

    mutations: {
        getSocialMedia: function getSocialMedia(state, payload) {
            state.socialMediaState = payload;
        },
        saveSocialMedia: function saveSocialMedia(state, payload) {
            var stateRef = state.socialMediaState;

            if (payload.editId) {
                var record = stateRef.find(function (item) {
                    return item.id === payload.editId;
                });
                stateRef.splice(stateRef.indexOf(record), 1, payload.newData);
            } else {
                stateRef.push(payload.newData);
            }
        }
    },

    actions: {
        getSocialMedia: function getSocialMedia(_ref) {
            var commit = _ref.commit,
                state = _ref.state,
                rootGetters = _ref.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'];

            if (_.isEmpty(state.socialState)) {
                axios.get(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["a" /* socialMedia */])(entityId, profileId)).then(function (response) {
                    commit('getSocialMedia', response.data.socialMedia);
                }).catch(function () {});
            }
        },
        saveSocialMedia: function saveSocialMedia(_ref2, formData) {
            var commit = _ref2.commit,
                rootGetters = _ref2.rootGetters;

            var profileId = rootGetters['profile/memberId'],
                entityId = rootGetters['profile/entityId'],
                requestUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_profile__["a" /* socialMedia */])(entityId, profileId),
                requestType = 'post';

            if (formData.editId) {
                requestUrl += '/' + formData.editId;
                requestType = 'put';
            }

            var promise = axios[requestType](requestUrl, formData.newData);

            promise.then(function (response) {
                commit('saveSocialMedia', {
                    editId: formData.editId,
                    newData: response.data.socialMedia
                });
            }, function (error) {});

            return promise;
        }
    }
});

/***/ }),

/***/ 413:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 414:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 415:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 416:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 117,
	"./af.js": 117,
	"./ar": 124,
	"./ar-dz": 118,
	"./ar-dz.js": 118,
	"./ar-kw": 119,
	"./ar-kw.js": 119,
	"./ar-ly": 120,
	"./ar-ly.js": 120,
	"./ar-ma": 121,
	"./ar-ma.js": 121,
	"./ar-sa": 122,
	"./ar-sa.js": 122,
	"./ar-tn": 123,
	"./ar-tn.js": 123,
	"./ar.js": 124,
	"./az": 125,
	"./az.js": 125,
	"./be": 126,
	"./be.js": 126,
	"./bg": 127,
	"./bg.js": 127,
	"./bm": 128,
	"./bm.js": 128,
	"./bn": 129,
	"./bn.js": 129,
	"./bo": 130,
	"./bo.js": 130,
	"./br": 131,
	"./br.js": 131,
	"./bs": 132,
	"./bs.js": 132,
	"./ca": 133,
	"./ca.js": 133,
	"./cs": 134,
	"./cs.js": 134,
	"./cv": 135,
	"./cv.js": 135,
	"./cy": 136,
	"./cy.js": 136,
	"./da": 137,
	"./da.js": 137,
	"./de": 140,
	"./de-at": 138,
	"./de-at.js": 138,
	"./de-ch": 139,
	"./de-ch.js": 139,
	"./de.js": 140,
	"./dv": 141,
	"./dv.js": 141,
	"./el": 142,
	"./el.js": 142,
	"./en-SG": 143,
	"./en-SG.js": 143,
	"./en-au": 144,
	"./en-au.js": 144,
	"./en-ca": 145,
	"./en-ca.js": 145,
	"./en-gb": 146,
	"./en-gb.js": 146,
	"./en-ie": 147,
	"./en-ie.js": 147,
	"./en-il": 148,
	"./en-il.js": 148,
	"./en-nz": 149,
	"./en-nz.js": 149,
	"./eo": 150,
	"./eo.js": 150,
	"./es": 153,
	"./es-do": 151,
	"./es-do.js": 151,
	"./es-us": 152,
	"./es-us.js": 152,
	"./es.js": 153,
	"./et": 154,
	"./et.js": 154,
	"./eu": 155,
	"./eu.js": 155,
	"./fa": 156,
	"./fa.js": 156,
	"./fi": 157,
	"./fi.js": 157,
	"./fo": 158,
	"./fo.js": 158,
	"./fr": 161,
	"./fr-ca": 159,
	"./fr-ca.js": 159,
	"./fr-ch": 160,
	"./fr-ch.js": 160,
	"./fr.js": 161,
	"./fy": 162,
	"./fy.js": 162,
	"./ga": 163,
	"./ga.js": 163,
	"./gd": 164,
	"./gd.js": 164,
	"./gl": 165,
	"./gl.js": 165,
	"./gom-latn": 166,
	"./gom-latn.js": 166,
	"./gu": 167,
	"./gu.js": 167,
	"./he": 168,
	"./he.js": 168,
	"./hi": 169,
	"./hi.js": 169,
	"./hr": 170,
	"./hr.js": 170,
	"./hu": 171,
	"./hu.js": 171,
	"./hy-am": 172,
	"./hy-am.js": 172,
	"./id": 173,
	"./id.js": 173,
	"./is": 174,
	"./is.js": 174,
	"./it": 176,
	"./it-ch": 175,
	"./it-ch.js": 175,
	"./it.js": 176,
	"./ja": 177,
	"./ja.js": 177,
	"./jv": 178,
	"./jv.js": 178,
	"./ka": 179,
	"./ka.js": 179,
	"./kk": 180,
	"./kk.js": 180,
	"./km": 181,
	"./km.js": 181,
	"./kn": 182,
	"./kn.js": 182,
	"./ko": 183,
	"./ko.js": 183,
	"./ku": 184,
	"./ku.js": 184,
	"./ky": 185,
	"./ky.js": 185,
	"./lb": 186,
	"./lb.js": 186,
	"./lo": 187,
	"./lo.js": 187,
	"./lt": 188,
	"./lt.js": 188,
	"./lv": 189,
	"./lv.js": 189,
	"./me": 190,
	"./me.js": 190,
	"./mi": 191,
	"./mi.js": 191,
	"./mk": 192,
	"./mk.js": 192,
	"./ml": 193,
	"./ml.js": 193,
	"./mn": 194,
	"./mn.js": 194,
	"./mr": 195,
	"./mr.js": 195,
	"./ms": 197,
	"./ms-my": 196,
	"./ms-my.js": 196,
	"./ms.js": 197,
	"./mt": 198,
	"./mt.js": 198,
	"./my": 199,
	"./my.js": 199,
	"./nb": 200,
	"./nb.js": 200,
	"./ne": 201,
	"./ne.js": 201,
	"./nl": 203,
	"./nl-be": 202,
	"./nl-be.js": 202,
	"./nl.js": 203,
	"./nn": 204,
	"./nn.js": 204,
	"./pa-in": 205,
	"./pa-in.js": 205,
	"./pl": 206,
	"./pl.js": 206,
	"./pt": 208,
	"./pt-br": 207,
	"./pt-br.js": 207,
	"./pt.js": 208,
	"./ro": 209,
	"./ro.js": 209,
	"./ru": 210,
	"./ru.js": 210,
	"./sd": 211,
	"./sd.js": 211,
	"./se": 212,
	"./se.js": 212,
	"./si": 213,
	"./si.js": 213,
	"./sk": 214,
	"./sk.js": 214,
	"./sl": 215,
	"./sl.js": 215,
	"./sq": 216,
	"./sq.js": 216,
	"./sr": 218,
	"./sr-cyrl": 217,
	"./sr-cyrl.js": 217,
	"./sr.js": 218,
	"./ss": 219,
	"./ss.js": 219,
	"./sv": 220,
	"./sv.js": 220,
	"./sw": 221,
	"./sw.js": 221,
	"./ta": 222,
	"./ta.js": 222,
	"./te": 223,
	"./te.js": 223,
	"./tet": 224,
	"./tet.js": 224,
	"./tg": 225,
	"./tg.js": 225,
	"./th": 226,
	"./th.js": 226,
	"./tl-ph": 227,
	"./tl-ph.js": 227,
	"./tlh": 228,
	"./tlh.js": 228,
	"./tr": 229,
	"./tr.js": 229,
	"./tzl": 230,
	"./tzl.js": 230,
	"./tzm": 232,
	"./tzm-latn": 231,
	"./tzm-latn.js": 231,
	"./tzm.js": 232,
	"./ug-cn": 233,
	"./ug-cn.js": 233,
	"./uk": 234,
	"./uk.js": 234,
	"./ur": 235,
	"./ur.js": 235,
	"./uz": 237,
	"./uz-latn": 236,
	"./uz-latn.js": 236,
	"./uz.js": 237,
	"./vi": 238,
	"./vi.js": 238,
	"./x-pseudo": 239,
	"./x-pseudo.js": 239,
	"./yo": 240,
	"./yo.js": 240,
	"./zh-cn": 241,
	"./zh-cn.js": 241,
	"./zh-hk": 242,
	"./zh-hk.js": 242,
	"./zh-tw": 243,
	"./zh-tw.js": 243
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 427;

/***/ }),

/***/ 434:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(448),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 435:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(444),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 436:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(418)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(442),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(449),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(419)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(325),
  /* template */
  __webpack_require__(443),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 439:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(318),
  /* template */
  __webpack_require__(450),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 440:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(422)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(447),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 441:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(420)
}
var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(445),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-490e830e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 442:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 443:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 444:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default", [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 445:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    staticClass: "main"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "people hidden-sm hidden-xs",
    style: ({
      background: 'url(' + _vm.featuredImage + ') center no-repeat',
      backgroundSize: 'cover'
    })
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "main_content"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "alt": "community management logo"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "main_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', {
    staticClass: "title_bottom_text"
  }, [_vm._v(_vm._s(_vm.subTitle))]), _vm._v(" "), _c('div', {
    staticClass: "login_area"
  }, [_c('h3', [_vm._v("\n                            Welcome To " + _vm._s(_vm.title) + ". Please Login To Access.\n                        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-lg btn-success login_btn",
    on: {
      "click": function($event) {
        _vm.makeLogin('sensa')
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.buttonText)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "bottom_text"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.footerText)
    }
  })])])])])])])
},staticRenderFns: []}

/***/ }),

/***/ 446:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-height",
    attrs: {
      "id": "app"
    }
  }, [(_vm.user) ? _c('navbar', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "user": _vm.user,
      "api": _vm.api
    }
  }), _vm._v(" "), (_vm.user) ? _c('foot') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 447:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-default",
    style: (_vm.backgroundColor)
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('router-link', {
    staticClass: "navbar-brand",
    style: (_vm.fontColor),
    attrs: {
      "to": {
        name: 'dashboard'
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.appName) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bs-example-navbar-collapse-1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [(_vm.user) ? _c('li', {
    staticClass: "user-action dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    style: (_vm.fontColor),
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('span', {
    staticClass: "user-avatar"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.profile_photo_large ? _vm.user.profile_photo_large : '/static/images/blank-profile-picture.png',
      "alt": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "name"
  }, [_vm._v("\n                            Hello, " + _vm._s(_vm.user.first_name) + "\n                        ")])]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": _vm.profileLink,
      "target": "_blank"
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logout($event)
      }
    }
  }, [_vm._v("Logout")])])])]) : _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      },
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                            Login\n                        ")])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "navbar-form-custom navbar-form navbar-left hide"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    staticClass: "icon fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search"
    }
  })])])
}]}

/***/ }),

/***/ 448:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 449:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 450:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row text-xs-center"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footer_logo),
      expression: "footer_logo"
    }],
    staticClass: "col-sm-3"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.footer_logo,
      "alt": _vm.appTitle
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.footerText),
      expression: "footerText"
    }],
    staticClass: "col-md-9 text-sm-right"
  }, [_c('p', {
    staticClass: "copy",
    domProps: {
      "innerHTML": _vm._s(_vm.footerText)
    }
  })])])])])
},staticRenderFns: []}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return get; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return searchUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return basicInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return phones; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return emails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return addresses; });
/* unused harmony export getCitizenships */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return citizenships; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return employments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return educations; });
/* unused harmony export getSkills */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return skills; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return certifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return groups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return socialMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return memberships; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return userNotes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(25);

var PROFILES = 'profiles/';


var get = function get(params) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + PROFILES + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var searchUsers = function searchUsers(str) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + PROFILES + '?search=' + str;
};

var basicInfo = function basicInfo(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId);
};

var getContacts = function getContacts(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '?fields=addresses,phones,emails');
};

var phones = function phones(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/phones');
};

var emails = function emails(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/emails');
};

var addresses = function addresses(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/addresses');
};

var getCitizenships = function getCitizenships(userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('' + PROFILES + userId + '?fields=citizenships{country,type}');
};

var citizenships = function citizenships(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/citizenships');
};

var employments = function employments(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/employments');
};

var educations = function educations(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/education');
};

var getSkills = function getSkills(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/skills?fields=certifications,professionalGroups');
};

var skills = function skills(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/skills');
};

var certifications = function certifications(userId, skillId) {
    var skillsURI = skills(userId);
    return skillsURI + ('/' + skillId + '/certifications');
};

var groups = function groups(userId, skillId) {
    var skillsURI = skills(userId);
    return skillsURI + ('/' + skillId + '/groups');
};

var socialMedia = function socialMedia(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/social-media');
};

var memberships = function memberships(entityId, userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('entities/' + entityId + '/' + PROFILES + userId + '/memberships');
};

var userNotes = function userNotes(userId) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + ('' + PROFILES + userId + '/notes');
};

/* harmony default export */ __webpack_exports__["n"] = ({
    basicInfo: basicInfo,
    citizenships: citizenships,
    phones: phones,
    emails: emails,
    addresses: addresses,
    employments: employments,
    educations: educations,
    skills: skills,
    certifications: certifications,
    groups: groups,
    socialMedia: socialMedia,
    memberships: memberships
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
    APP_NAME: window.APP_NAME,
    API_DOMAIN: window.API_DOMAIN,
    API_ROOT: window.API_DOMAIN + "/api/v1",
    DEFAULT_ORG: window.DEFAULT_ORG,
    AUTH_URL: window.API_DOMAIN + '/oauth/authorize',
    API_BASE_URL: window.API_DOMAIN + '/api/v1/organizations',
    APP_ID: window.SENSA_APP_ID,
    REDIRET: window.CLIENT_DOMAIN,
    AUTH_USER_URL: window.API_DOMAIN + '/api/v1/oauth/auth-user'
});

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export collections */
/* unused harmony export collectionReport */
/* unused harmony export collectionEntities */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return communities; });
/* unused harmony export communityChildrens */
/* unused harmony export collectionRoles */
/* unused harmony export storeCommunityOrder */
/* unused harmony export detachEntities */
/* unused harmony export importCommunities */
/* unused harmony export collectionProfileSearch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return collectionProfiles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__env__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__index__ = __webpack_require__(25);



var COLLECTIONS = 'collections/';

var collections = function collections() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var params = arguments[1];

    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + COLLECTIONS + (id || '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var collectionReport = function collectionReport(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + COLLECTIONS + id + '/report' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var collectionEntities = function collectionEntities(id, params) {
    return collections(id) + '/entities' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var communities = function communities() {
    var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var params = arguments[1];

    return collections(id) + '/communities' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var communityChildrens = function communityChildrens(collectionId, communitId, params) {
    return communities(collectionId) + '/' + communitId + '/childrens' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var collectionRoles = function collectionRoles(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + 'collections/' + id + '/roles' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var storeCommunityOrder = function storeCommunityOrder(id) {
    return communities(id) + '/sort';
};

var detachEntities = function detachEntities(id, params) {
    return collections(id) + '/detach-entities' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var importCommunities = function importCommunities(id) {
    return collections(id) + '/import-entities';
};

var collectionProfileSearch = function collectionProfileSearch(id, params) {
    return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + COLLECTIONS + id + '/profiles/search' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
};

var collectionProfiles = {
    find: function find(collection_id, profile_id, params) {
        return __WEBPACK_IMPORTED_MODULE_0__env__["a" /* API_ROOT */] + COLLECTIONS + collection_id + '/profiles/' + profile_id + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__index__["a" /* buildUri */])(params);
    }
};

/* harmony default export */ __webpack_exports__["b"] = ({
    collections: collections,
    collectionReport: collectionReport,
    collectionEntities: collectionEntities,
    communities: communities,
    collectionRoles: collectionRoles,
    storeCommunityOrder: storeCommunityOrder,
    communityChildrens: communityChildrens,
    detachEntities: detachEntities,
    importCommunities: importCommunities,
    collectionProfileSearch: collectionProfileSearch
});

/***/ })

},[329]);


// WEBPACK FOOTER //
// static/js/app.f834a7aaf4871c56c9ef.js